export default {
  channelType: 'Three-way channel type',
  lastcreator: 'last creator',
  subotp: 'Submit verification code',
  zalopayId: 'zalo account number',
  enterotp: 'Please enter the verification code',
  payinfo: 'payee information',
  paycode: 'Payment QR code',
  transCode: '交易码',
  receipt: 'receipt',
  confirm: 'Submit',
  serialNumber: 'device number',
  userName: 'The username of the account',
  phone: 'Mobile phone number',
  connectionStatus: 'Connection Status',
  limits: 'Limit limit of the day',
  monthLimits: 'Limit of the current month',
  receivedDayMoney: 'Amount received on the day',
  receivedTotalMoney: 'Total amount received',
  id: 'id',
  payOrder: 'Transaction number',
  deviceOrder: 'device number',
  payType: 'transfer type',
  payMoney: 'transaction amount',
  remark: 'Description',
  callbackStatus: 'callback status',
  createTime: 'Creation Date',
  tranid: 'transaction number',
  tranType: 'transfer type',
  amount: 'transaction amount',
  description: 'Description',
  updates: 'Upload',
  exportIn: 'import',
  orderNumberTotal: 'Transaction Quantity',
  paymentAmountTotal: 'Total amount received',
  history: 'History',
  bankName: 'Bank Name',
  bankAccount: 'Bank card number',
  bankCode: 'bank code',
  payName: 'payee name',
  loginAccount: 'login account',
  proQrStatus: 'General code status',
  bankQrStatus: 'Bank code scanning status',
  momoBankStatus: 'momo bank status',
  bankTransferStatus: 'Bank card transfer status',
  apiStatus: 'api pull record status',
  momo_bankStatus: 'momobank  status',
  zalobankStatus: 'zalobank  status',
  vtpbankStatus: 'vtpbank  status',
  balance: 'account balance',
  successTodayAmount: 'Successful transaction amount of the day',
  content: 'Content',
  source: 'source',
  accountNumber: 'transaction amount',
  io: 'transfer type',
  partnerPhone: 'payment phone number',
  finishTime: 'Transfer time',
  fee: 'handling fee',
  apptrandsId: 'apptransid',
  sourceType: 'Record source',
  systemOrderNo: 'system order number',
  status: 'Transaction Status',
  senderAccount: 'withdrawal account',
  senderName: 'Withdrawal name',
  senderBankCode: 'withdrawal bank',
  receiverNumber: 'receiver account number',
  receiverName: 'Receiver Name',
  receiverBankCode: 'recipient bank',
  createDate: 'Creation time',
  createBy: 'Creator',
  confirmDate: 'Confirmation time',
  confirmBy: 'Withdrawal operator',
  error: 'error message',
  payBankId: 'payment bank id',
  offstatus: 'state',
  Changestate: 'Is it enabled',
  Changestateoff: 'Whether to close',
  minimumAmount: 'Minimum payment amount',
  maximumAmount: 'Maximum payment amount',
  withdrawTodayAmount: 'Withdrawal amount on the day',
  description: 'Operation description',
  ipAddress: 'Operation IP address',
  beforeOperation: 'Pre-operational data',
  afterOperation: 'Post-operation data',
  LoginBackground: 'Log in to the background',
  LoginIP: 'Login IP',
  PayforIP: 'Pay for IP',
  momohistory: 'MOMO history',
  zalohistory: 'ZALO history',
  viettelhistory: 'VIETTEL history',
  paybankhistory: 'Bank history',
  inTranAmountTotal: 'Total amount collected',
  inTranTotal: 'Total number of payments received',
  outTranAmountTotal: 'Total withdrawal amount',
  outTranTotal: 'Total number of withdrawals',
  pullBalance: 'Balance',
  btnLeft: 'Please slowly shake your head to the left',
  btnRight: 'Please slowly shake your head to the right',
  btnZoomIn: 'Bring your phone closer',
  btnZoomOut: 'Zoom out mobile phone',
  btnFrontAndBlink: 'Please look at the camera and blink',
  btnRedLight: 'Huang Guang',
  btnYellowLight: 'Huang Guang',
  btnBlueLight: 'Blu-ray',
  facevideoTip: 'No video recorded at this time',
  facevideo: 'Face Video',
  tip: '(TCB must upload video)',
  btnOrangeLight: 'Orange Light',
  btnFront: 'Please look directly at the camera',
  bankPayType: 'Collecting bank type',
  connectionStatusOption: [
    {
      value: '',
      label: 'all'
    },
    {
      value: 0,
      label: 'Disconnect'
    },
    {
      value: 1,
      label: 'Link'
    }
  ],
  add_connectionStatusOption: [
    {
      value: 0,
      label: 'Disconnect'
    },
    {
      value: 1,
      label: 'Link'
    }
  ],
  callbackStatusOption: [
    {
      value: 2,
      label: 'Callback'
    },
    {
      value: 1,
      label: 'Not Called Back'
    }
  ],
  statusOption: [
    {
      value: 1,
      label: 'open'
    },
    {
      value: 2,
      label: 'closed'
    }
  ],
  transpayTo: [
    {
      value: 0,
      label: 'Payment'
    },
    {
      value: 1,
      label: 'Receipt'
    }
  ],
  b_transpayTo: [
    {
      value: 1,
      label: 'Receipt'
    },
    {
      value: 2,
      label: 'Withdrawal'
    },
    {
      value: 3,
      label: 'Payment'
    }
  ],
  recordStatus: [
    {
      value: 0,
      label: 'processing'
    },
    {
      value: 1,
      label: 'failure'
    },
    {
      value: 2,
      label: 'success'
    }
  ],
  paystatus: [
    {
      value: 0,
      label: 'processing'
    },
    {
      value: 1,
      label: 'failed'
    },
    {
      value: 2,
      label: 'success'
    }
  ],
  rules: {
    //Device No
    serialNumber: 'Please enter the device number',
    //Phone number
    phone: 'Please enter your phone number',
    //Connection Status
    connectionStatus: 'Please select the connection status',
    //The day's payment limit
    limits: 'Please enter the receiving limit for the day',
    //Current payment limit
    monthLimits: 'Please enter the payment limit for the current month'
  },
  mo_history: {
    id: 'id',
    serialNumber: 'Mobile phone number',
    phone: 'Receiving phone number',
    userName: 'Payee Name',
    tranid: 'transaction number',
    tranType: 'receipt type',
    amount: 'amount',
    description: 'Description',
    partnerId: 'Transfer phone number',
    partnerName: 'Transfer party name',
    payTime: 'payment time',
    createTime: 'Creation time',
    merchantOrderNo: 'merchant order number',
    merchantNo: 'merchant number',
    merchantName: 'merchant name',
    transactionDate: 'transactionDate'
  },
  all: {
    del: 'Batch delete',
    edit: 'Batch modification',
    offorturn: 'Batch opening and closing:'
  },
  down: {
    a1: 'Select the .xlsx file to upload',
    a2: 'Or drag and drop the .xlsx file here',
    a3: 'Download template',
    close: 'close',
    confirm: 'confirm',
    selectfile: 'Please select the file first',
    ImportSuccess: 'Import successful',
    Importfailed: 'Import failed'
  },
  withdrawal: {
    paystatus: [
      {
        value: -1,
        label: 'failed'
      },
      {
        value: 1,
        label: 'success'
      }
    ],
    transferTypes: [
      'Transferring funds to external accounts',
      'Transfer funds to linked accounts',
      'Internal account transfer',
      'momo representative'
    ],
    orderNumberTotal: 'orderNumberTotal',
    realAmount: 'realAmount',
    totalfee: 'totalfee',
    statistics: 'statistics',
    appTransId: 'appTransId',
    phone: 'phone',
    serial: 'serial',
    transId: 'ZALO订单号',
    payId: '账号',
    receiverNumber: '收款账号',
    senderNumber: '提款账号',
    receiverName: '收款人姓名',
    amount: 'amount',
    fee: 'fee',
    total: 'total',
    status: 'status',
    message: 'message',
    error: 'error',
    creator: '操作人',
    created: '操作时间',
    momo: {
      orderNumberTotal: '实收金额',
      realAmount: '总金额',
      totalfee: '手续费',
      statistics: '统计',
      fulldata: '系统单号',
      tranId: 'MOMO订单号',
      accountPhone: 'momo账号',
      rowCardNum: '收款卡号',
      partnerName: '收款人姓名',
      originalAmount: '到账金额',
      fee: '手续费',
      amount: '总金额',
      sodu: '转账前余额',
      balance: '转账后余额',
      errorDesc: '描述',
      type: '区域类型',
      username: '操作人',
      status: '订单状态',
      createTime: '创建时间',
      serial: '设备序列号'
    }
  },
  owner_merchant_no: 'Merchant',
  lastAccept: 'Last payment time',
  walletType: 'Wallet Type',
  普通钱包: 'Ordinary wallet',
  财神钱包: 'Golden Poket Wallet'
};



// WEBPACK FOOTER //
// ./src/i18n/lang/en/device.js